import { AiModelAction } from '../actions/aiModel';

const initialState = process.env.AI_MODEL || 'gpt-4o-mini';

const aiModelReducer = (state = initialState, action: AiModelAction) => {
	switch (action.type) {
		case 'ai-model/select':
			return action.payload;
		default:
			return state;
	}
};

export default aiModelReducer;
